import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import { Divider } from "@mui/material";
import { stringAvatar } from "../utilities/AvatarModifiers";

export default function ProfileCard(props) {
    const { user, darkState } = props;

    return (
        <Card
            elevation={0}
            sx={{
                my: 1,
                width: "100%",
                maxWidth: "500px",
                border: darkState ? "1.5px solid" : "3px solid",
                borderColor: "primary.main",
                borderRadius: "16px",
                marginTop: "2rem",
            }}
        >
            <CardContent
                style={{
                    marginBottom: 0,
                    paddingBottom: 0,
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <Avatar
                    style={{ width: 56, height: 56 }}
                    {...stringAvatar(`${user.first_name} ${user.last_name}`)}
                />
            </CardContent>
            <CardContent
                sx={{ marginTop: 0, paddingTop: 0, textAlign: "center" }}
            >
                <Typography sx={{ mb: 1 }} variant="h5" component="div">
                    {`${user.first_name} ${user.last_name}`}
                </Typography>
                <Divider sx={{ ml: 6, mr: 6 }} />
                <Typography
                    sx={{ fontSize: 14, mb: 2, mt: 2 }}
                    color="text.secondary"
                    gutterBottom
                >
                    User Name: {user.username}
                    <br />
                    Email: {user.email}
                    <br />
                </Typography>
                <Divider sx={{ ml: 6, mr: 6 }} />
                <Typography sx={{ mb: 2, mt: 2 }} color="text.primary">
                    Permission level:{" "}
                    {user.is_staff ? "Admin" : "Limited Access"}
                </Typography>
                {user.groups.length > 0 ? (
                    <>
                        <Divider sx={{ ml: 6, mr: 6 }} />
                        <Typography sx={{ mb: 2, mt: 2 }} color="text.primary">
                            Groups: [
                            {user.groups.map((group, i) =>
                                i < user.groups.length - 1
                                    ? ` ${group.name},`
                                    : ` ${group.name} `
                            )}
                            ]
                        </Typography>
                    </>
                ) : (
                    ""
                )}
            </CardContent>
        </Card>
    );
}
